import React from 'react';
import SliderComponent from './SliderComponent';

export default function Contact(){
	return(
		<>
		<SliderComponent />
	<section className="container-wrapper">
	
	    <h2>Contact Us</h2>
	    <p>Email: info@bridgingskilled.com</p>
	    <p>Phone: +91-9876543210</p>
	    <p>Location: Delhi, India</p>
  </section>
  </>
	)
}